import { render, staticRenderFns } from "./Wx_category.vue?vue&type=template&id=0654fef9&"
import script from "./Wx_category.vue?vue&type=script&lang=js&"
export * from "./Wx_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports